import styled from 'styled-components';

export const CollapsableContainer = styled.div(
    props => `
        max-height: ${props.cHeight};
        z-index: 1;
        overflow: hidden;
`);

export const CollapsableContainerText = styled.div(
    props => `
        box-shadow: 0 -1.5rem 1.5rem 0.5rem ${props.shadowColor || "#fff"};
        z-index: 2;
        color: #2276e3;
        width: 75px;
    `
);
